"use client";

import { PageHomeSchema } from "@/sanity/pages/PageHomeTemplate";
import NewPricingSection from "@/components/pageComponents/newPricing/NewPricingSection";

/**
 * The homepage pricing section — the new pricing experience (spec:
 * IQ-Capital-Pricing-Spec-for-IT.md, Figma "IQ Capital | New UI 2026").
 * The pricingSectionV3 doc drives every number, string and logo (falling back
 * to lib/new-pricing/products.ts + newPricing/copy.ts); the legacy
 * pricingSectionV2 doc still supplies the platforms-footer fallback.
 */
export default function TailoredFundingSection({
  data,
  afterBanner = false,
}: {
  data: PageHomeSchema;
  /** The Trading Competition banner sits between the hero and this section. */
  afterBanner?: boolean;
}) {
  return (
    <NewPricingSection
      section={data?.tailoredFundingSectionV2}
      sectionV3={data?.pricingSectionV3}
      language={data?.settings?.language}
      // Straight after the hero, mobile tucks into the hero's bottom margin and the desktop padding
      // follows the hero's per-breakpoint margin. After the banner (which does the tuck itself) one
      // padding fits every width.
      sectionClassName={
        afterBanner
          ? "pt-0 lg:pt-[9.5rem] lg:pb-[19rem] z-[99]"
          : "pt-0 lg:pt-[14.5rem] 2xl:pt-[9.5rem] lg:pb-[19rem] -mt-[7.5rem] z-[99] lg:-mt-0"
      }
    />
  );
}
